<template>

<div class="singlePost">
<div class="latestInfoEntry">
<p class="timestamp"> Tuesday, March 15th 2011 </p>
<h4>Response to "Milk sharing: Boon or biohazard," published in the Canadian Medical Association Journal </h4>
<p><a href ="/docs/Milksharing_boon_or_biohazard.pdf" target="_blank">CMAJ: Milk Sharing: Boon or Biohazard?</a></p>
<p><em>By Maria Armstrong, Founder of Eats on Feets</em></p>
<p>Dear Lauren,</p>

<p>Please allow me to post some corrections.</p>

<p>Routine prenatal testing is inconclusive when it comes to safe milk sharing. It does not address every disease milk is typically screened for, and testing is primarily done at the beginning of pregnancy. Many opt out of HIV screening. Both HMBANA and UKAMB recommend testing every 3-6 months for HIV, HTLV, HBV, HCV, Syphilis and Rubella. These guidelines are followed by most milk banks.</p>

<p>The only country I know of that relies on donor screening alone is Norway. Milk banks generally also use the Holder method of pasteurization for safety.</p>

<p>Regarding pasteurizing breastmilk, flash-pasteurizing is a commercial method that requires special equipment and cannot be duplicated in a home setting. What can be done at home is called "flash-heating." The only virus that this method has demonstrated to inactivate is HIV. While flash-pasteurizing has shown to inactivate  HIV, HTLV, HBV and HCV, and CMV as well as markers for many other viruses, the effectiveness of flash-heating on viruses other than HIV is theoretical. </p>

<p>It is important to note is that any pasteurizing of breastmilk raises the risk of spore release from spore-forming bacteria.  </p>

<p>When mothers look for information for safe breastmilk sharing, it is important that all available information is presented. Deviation from standard is and should be a personal choice and not the only information given.</p>
</div>
<div class="references" >
  <p><strong>Bio</strong></p>
<p>Maria Armstrong is the mother of 4 and a doula serving the Portland, OR Metro Area and Vancouver, WA. Maria has a keen eye for research, a strong affinity for personal agency as well as autonomy, and is a strong advocate for families wherever she finds herself.
</p>
</div>
</div>
</template>
<script>
export default {
  name: 'CMJResponse'
}
</script>

<style lang="scss">
.references {
  font-size: .8em;
}
</style>
